// Settings Page
import React from 'react';
import { NextSeo } from 'next-seo';
import { NextPageWithLayout } from 'types/page';
import { getAppLayout } from 'components/containers/AppLayout';
import SettingsView from 'components/views/Settings';
import AuthPageProtection from 'components/containers/AuthProtection';
import SettingsStyles from 'components/views/Settings/Settings.module.sass';
import ROUTES from 'config/routes';

/**
 * Settings: Page description
 * @return {NextPageWithLayout}
 */
const PageTitle = 'Settings';
const Settings: NextPageWithLayout = () => {
  return (
    <>
      <AuthPageProtection
        options={{ permissions: ROUTES.AccountSettings.permissions }}
      >
        <NextSeo title={PageTitle} />
        <SettingsView />
      </AuthPageProtection>
    </>
  );
};

Settings.getLayout = getAppLayout({
  title: PageTitle,
  headerClassName: SettingsStyles.settingsHeader,
});

export default Settings;
